var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.24,13.02H1.97c-.55,0-1-.45-1-1V1.43C.97.88,1.42.43,1.97.43h95.27c.55,0,1,.45,1,1v10.59c0,.55-.45,1-1,1ZM2.97,11.02h93.27V2.43H2.97v8.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.72,98.78c-.18,0-.35-.05-.51-.14-.3-.18-.49-.51-.49-.86v-42.21L5.03,25.05c-.23-.19-.36-.47-.36-.77v-12.26c0-.55.45-1,1-1s1,.45,1,1v11.79l36.69,30.53c.23.19.36.47.36.77v40.99l11.15-6.06v-34.94c0-.3.13-.58.37-.77l37.3-30.52v-11.78c0-.55.45-1,1-1s1,.45,1,1v12.26c0,.3-.13.58-.37.77l-37.3,30.53v35.06c0,.37-.2.7-.52.88l-13.15,7.14c-.15.08-.31.12-.48.12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.59,88.59c-.39,0-.75-.22-.92-.6-.22-.51,0-1.1.52-1.32l12.28-5.37c.51-.22,1.09,0,1.32.51.22.51,0,1.1-.52,1.32l-12.28,5.37c-.13.06-.27.08-.4.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.1141fdff08ac395f9f6fcf9d511589a6.svg";
export { ForwardRef as ReactComponent };